<template>
  <div class="p-grid">
      <div class="p-col-12">
        <div class="p-fluid p-formgrid p-grid">
           <div class="p-field p-col-12 p-md-6">
               <label>Empresa</label>
               <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                @change="listarCentrosCustos"/>
           </div>
           <div class="p-field p-col-12 p-md-6">
               <label>Escala de horário atual</label>               
               <Dropdown v-model.number="idContratoSelecionado" :options="contratos" optionLabel="descricao" optionValue="id" placeholder="Selecione"
                @change="buscarFuncionarios"/>
           </div> 
           <div class="p-field p-col-12 p-md-6">
               <label>Centro de custo</label>               
               <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                dataKey="keyRefId" @change="buscarFuncionarios"/>
           </div>           
           <div class="p-field p-col-12 p-md-6">
               <label style="color: #ffffff">.</label>
               <div class="p-inputgroup">
                   <InputText v-model.trim="crachaNome" 
                   @keyup.enter="buscarFuncionariosCrachaNome" 
                   @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')"
                   placeholder="crachá/pis/cpf/nome"/>
                   <Button label="Buscar" @click="buscarFuncionariosCrachaNome"/>                    
                </div>
           </div>                      
        </div>        
        <PickList v-model="funcionarios" listStyle="height:342px" dataKey="id">
            <template #sourceHeader>
                Funcionários Disponíveis
            </template>
            <template #targetHeader>
                Funcionários Selecionados
            </template>
            <template #item="slotProps">
               <div>
                   {{slotProps.item.cracha}} {{slotProps.item.nome}}
               </div>
           </template> 
        </PickList>
        <div class="p-fluid p-formgrid p-grid p-mt-5">           
           <div class="p-field p-col-4 p-md-4">
               <label>Nova escala</label>
               <Dropdown v-model.number="idNovoContratoSelecionado" :options="contratosNovo" optionLabel="descricao" optionValue="id" placeholder="Selecione"/>
           </div>
           <div class="p-field p-col-4 p-md-4">
               <label>Data início</label>
               <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"
                :locale="localeCalendarBR"/>
           </div>                     
        </div> 
        <Button label="Salvar" class="p-button-primary" icon="pi pi-check" @click="trocarContratoFuncionarios" v-if="permissaoEditar"/>        
    </div>
   
  </div>
</template>

<script>
import FuncionarioPesquisaService from '@/service/FuncionarioPesquisaService';
import CentroCustoService from '@/service/CentroCustoService';
import ConfiguracaoEscalaService from '@/service/ConfiguracaoEscalaService';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR } from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    centroCustoService: null,
    funcionarioPesquisaService: null,
    configuracaoEscalaService: null,
    data() {
        return {
            permissaoEditar: false,
            crachaNome: '',
            dataInicio: new Date(),
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            idContratoSelecionado: null,
            idNovoContratoSelecionado: null,
            cnpjs:[],
            contratos: [],
            contratosNovo: [],
            centrosCustos: [],
            funcionarios: null,
            localeCalendarBR: localeCalendarBR
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes', 'getCacheEmpresa']),
        ...mapActions('sessao', ['atualizarCacheEmpresa']),
        trocarContratoFuncionarios() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            if(this.idNovoContratoSelecionado == null) {
                exibirMensagemSis(this, 'Selecione a nova escala', true);
                return;
            }
            if(this.idNovoContratoSelecionado == this.idContratoSelecionado) {
                exibirMensagemSis(this, 'A nova escala é igual a atual', true);
                return;
            }
            if(this.funcionarios == null || this.funcionarios[1].length == 0) {
                exibirMensagemSis(this, 'Selecione um funcionário', true);
                return;
            }
            let idsFuncionarios = [];
            this.funcionarios[1].forEach(funcio => {
                idsFuncionarios.push(funcio.id);
            });
            let requisicao = {
                idsFuncionarios: idsFuncionarios,
                idNovoContrato: this.idNovoContratoSelecionado,
                idAntigoContrato: this.idContratoSelecionado,
                dataInicio: this.dataInicio,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.configuracaoEscalaService.trocarContratoFuncionarios(requisicao)
				.then(resp => {                                          
                    this.funcionarios = null;
                    exibirMensagem(this, resp);	                 
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        buscarFuncionarios(){
            if(this.idCnpjSelecionado == null || !this.idContratoSelecionado 
            || this.idContratoSelecionado == null || (typeof this.idContratoSelecionado === undefined)) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let requisicao = {
                idsCentrosCustos: idsCentrosCustos,
                idContrato: this.idContratoSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.funcionarioPesquisaService.buscarFuncionariosContrato(requisicao)
				.then(resp => {                                          
                    this.funcionarios = [resp.data, []];                  
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        buscarFuncionariosCrachaNome(){
            if(this.idCnpjSelecionado == null || !this.idContratoSelecionado 
            || this.idContratoSelecionado == null || (typeof this.idContratoSelecionado === undefined)) {
                exibirMensagemSis(this, 'Selecione uma empresa e a escala atual', true);
                return;
            }
            if(this.crachaNome == '') {
                this.funcionarios = null;
                return;
            }
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ct => {
                    if(ct.id != null) {
                        idsCentrosCustos.push(ct.id);
                    }                    
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }
            let requisicao = {
                crachaNome: this.crachaNome,
                idsCentrosCustos: idsCentrosCustos,
                idContrato: this.idContratoSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.funcionarioPesquisaService.buscarFuncionariosContratoCrachaNome(requisicao)
				.then(resp => {                                          
                    this.funcionarios = [resp.data, []];                  
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        listarContratosCnpjs() {
            let usuarioRequisicao = {...this.getDadosRequisicao()};
            this.funcionarioPesquisaService.listarContratos(usuarioRequisicao)
            .then(resp => {			
                this.contratos = resp.data;
                this.contratosNovo = resp.data;
            })
            .catch(erro => {exibirMensagem(this, erro)});
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            centroCusto['keyRefId'] = Date.now();
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        listarCentrosCustos() {
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
            .then(resp => {                    
                // Cache dados      
                cacheEmpresa.centrosCustos = [];
                let dataKey = 1;               
                resp.data.forEach(ct => {
                    ct['keyRefId'] = dataKey++;
                    cacheEmpresa.centrosCustos.push({...ct});
                });   
                this.idContratoSelecionado = null;                     
                this.centrosCustos = []; 
                let centroCusto = new CentroCusto();
                centroCusto.nome = 'Todos';
                centroCusto['keyRefId'] = Date.now();   
                this.centrosCustos.push(centroCusto);
                Array.prototype.push.apply(this.centrosCustos, resp.data);  
                this.atualizarCacheEmpresa(cacheEmpresa);                    
            })
            .catch(erro => {exibirMensagem(this, erro)});
        },
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },
        validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoEditar = permissoes.includes(26);// Permissão para editar o funcionário		
		}
    },
    created() {
        this.centroCustoService = new CentroCustoService();
        this.funcionarioPesquisaService = new FuncionarioPesquisaService();
        this.configuracaoEscalaService = new ConfiguracaoEscalaService();
    },
    mounted() {
        this.validarPermissoes();
        this.listarContratosCnpjs();
    }
}
</script>

<style>
</style>